var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElastic01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-218{fill:#fff;stroke-width:2.54px;}.cls-218,.cls-219{stroke:#000;stroke-miterlimit:10;}.cls-219{fill:none;stroke-width:2.28px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 65.67,
    y: 221,
    width: 291.66,
    height: 47.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 79.94,
    y: 232.43,
    width: 4.52,
    height: 29.01
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 96.15,
    y: 232.43,
    width: 4.52,
    height: 29.01
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 112.35,
    y: 232.43,
    width: 4.52,
    height: 29.01
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 128.55,
    y: 232.43,
    width: 4.52,
    height: 29.01
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 144.76,
    y: 232.43,
    width: 4.52,
    height: 29.01
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 160.96,
    y: 232.43,
    width: 4.52,
    height: 29.01
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 177.16,
    y: 232.43,
    width: 4.52,
    height: 29.01
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 193.37,
    y: 232.43,
    width: 4.52,
    height: 29.01
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 209.57,
    y: 232.43,
    width: 4.52,
    height: 29.01
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 225.77,
    y: 232.43,
    width: 4.52,
    height: 29.01
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 241.98,
    y: 232.43,
    width: 4.52,
    height: 29.01
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 258.18,
    y: 232.43,
    width: 4.52,
    height: 29.01
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 274.38,
    y: 232.43,
    width: 4.52,
    height: 29.01
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 290.58,
    y: 232.43,
    width: 4.52,
    height: 29.01
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 306.79,
    y: 232.43,
    width: 4.52,
    height: 29.01
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 322.99,
    y: 232.43,
    width: 4.52,
    height: 29.01
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 339.19,
    y: 232.43,
    width: 4.52,
    height: 29.01
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-219",
    x: 65.67,
    y: 239.97,
    width: 291.66,
    height: 13.94
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElastic01);
export default __webpack_public_path__ + "static/media/elastic-01.48df6062f484df0ffce1510e184e168b.svg";
export { ForwardRef as ReactComponent };